import { TYPES_DICT } from '../retr-types'
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('retr', ['filters']),

        merchant() {
            const locId = this.filters.locationId.value
            const merchants = this.$store.getters.getAvailableMerchants
            const merchant = merchants.find(merchant => merchant.location_id === locId)

            return merchant
        },

        retrData() {
            return this.$store.getters.modalState.args
        },

        title() {
            const { type, contractor, element } = this.retrData
            return [TYPES_DICT[type], contractor, element].join(' / ')
        }
    }
}